"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { MobileMenu } from "./MobileMenu";
import {
  getAllActiveBanner,
  getAllActiveSettings,
} from "@/store/home/home.services";
import { getAllActiveActivity } from "@/store/activities/activity.services";
import { useAppDispatch } from "@/hooks/hooks";
import Image from "next/image";

export function Header() {
  const dispatch = useAppDispatch();
  const pathname = usePathname();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    dispatch(getAllActiveSettings());
    dispatch(getAllActiveBanner());
    dispatch(getAllActiveActivity());
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Match Vite's per-link active detection exactly
  const isActive = (path: string) => pathname === path;
  const startsWith = (path: string) => pathname?.startsWith(path);

  const navLinks = [
    {
      href: "/",
      label: "Home",
      active: isActive("/"),
    },
    {
      href: "/about-us/",
      label: "About",
      active: isActive("/about-us/") || startsWith("/about-us/"),
    },
    {
      href: "/rooms/",
      label: "Rooms",
      active: isActive("/rooms/") || startsWith("/rooms/"),
    },
    {
      href: "/activities/",
      label: "Activities",
      active: isActive("/activities/") || startsWith("/activities/"),
    },
    {
      href: "/attractions/",
      label: "Attractions",
      active: isActive("/attractions/") || startsWith("/attractions/"),
    },
    {
      href: "/gallery/",
      label: "Gallery",
      active: isActive("/gallery/") || startsWith("/gallery/"),
    },
    {
      href: "/blogs/",
      label: "Blogs",
      active: isActive("/blogs/") || startsWith("/blogs/"),
    },
    {
      href: "/contact-us/",
      label: "Contact",
      active: isActive("/contact-us/") || startsWith("/contact-us/"),
    },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
          ? "bg-[#F3EBDD]/98 backdrop-blur-lg shadow-lg border-b border-[#D8C4A8]/50"
          : "bg-transparent"
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <Link href="/" className="flex items-center">
            <div className="relative w-[160px] h-[64px]">
              <Image
                src="/logo.png"
                alt="Aranya Nature Retreat - A nature's paradise"
                fill
                priority
                className="object-contain"
                sizes="160px"
              />
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-10">
            {navLinks.map(({ href, label, active }) => (
              <Link
                key={href}
                href={href}
                style={{ fontWeight: 500 }}
                className={`transition-colors relative group ${active
                    ? "text-[#7A4A1D]"
                    : "text-[#5A3A1E] hover:text-[#7A4A1D]"
                  }`}
              >
                {label}
                <span
                  className={`absolute bottom-0 left-0 h-0.5 bg-[#E07A2F] transition-all ${active ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                ></span>
              </Link>
            ))}
          </div>

          <MobileMenu />
        </div>
      </div>
    </nav>
  );
}
